import { useCallback } from 'react'
import { getSelectedOrder } from '../../selectors/order'
import { useDispatch, useSelector } from 'react-redux'
import { setOrderInProgress, updateSavedPayment } from '../../actions/order'

/**
 * Hook for handling back bar actions
 *
 * @returns {Object}
 */
const useBackBar = () => {
  const dispatch = useDispatch()
  const order = useSelector(getSelectedOrder)

  /**
   * On "Confirm Tip & Close Tab", sets the order in progress and
   * updates the saved payment
   *
   * @param {number} tipAmountInCents
   */
  const confirmTipHandler = useCallback(
    (tipAmountInCents) => {
      dispatch(setOrderInProgress(order))
      dispatch(updateSavedPayment({ tipAmountInCents, isBackBar: true, tenderAmountInCents: order?.amountInCents || 0 }))
    },
    [dispatch, order],
  )
  return { confirmTipHandler }
}

export default useBackBar
